function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.85 12.44l4 4a.5.5 0 01-.02.69l-.7.7a.5.5 0 01-.71 0l-4-4a2.603 2.603 0 01-.3-.36l-.75-1A7 7 0 018 14a7 7 0 115.42-2.6l1 .69c.156.1.3.217.43.35zM3 7a5 5 0 1010 0A5 5 0 003 7z"
});

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 20 19",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgSearch;